export const THEME = {
    bgDark: '#14151f',
    bgLight: '#171823',
    text: '#bacddb',
    textLighter: '#dee7ed'
}